import React from 'react';

const toLines = (text) =>
    text
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean);

const termsText = `Pawansut Holdings Limited (the "Company", "we", "us" or "our") owns and operates a website i.e. https://www.finncube.com/ including its mobile applications and the Website. These terms and conditions ("Terms") shall govern the use or access to the Website and Services (as defined below). These Terms constitute a binding and enforceable legal contract between the Company and the user of the website ("you, your or user").
Unless defined herein, capitalized terms shall have the meaning ascribed to them under the Privacy Policy.

Important Notice
No information provided on the Website shall be considered a substitute for your independent investigation. These Terms are collectively an electronic record for the purpose of the Information Technology Act, 2000 ("IT Act") and the rules made thereunder.

These Terms do not require any digital or electronic signature. You must not modify the paper or digital copies of any materials you have printed, or downloaded from, our Websites in any way, and you must not use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text.

By using our Website, you confirm that you accept these Terms and that you agree to comply with them. If you do not agree to the Terms, you must not access this Website.

Who Are We and What Do We Do?
The Company is a private limited company incorporated under the Companies Act, 2013. The Company aims to deliver a unified platform wherein the company avail financing options and benefits accruing to customers in a single place.

The Website is owned and managed by the Company. Please read the Terms to acquaint yourself of the practices of the Company, with regard to your use of the domain and subdomains of our Website, which includes only the domains and subdomains being operated by the Company and does not include the domains or subdomains licensed out by the Company.

Service Availability
We hereby clarify that the Services mentioned on the Website are subject to availability. The Company reserves the right to modify, amend and/or alter the said Service(s) based on its sole discretion and no such Services shall be deemed to be any offer or acceptance by the Company unless the same are accepted by the Company separately in writing through its authorized representatives.

Services
The Website allows you to work out your eligibility using our Calculator and after documentation offers financing options to you. Please note the website is generic and offers directional estimates.

Liability Disclaimer
There is no liability for Pawansut Holdings Limited for anything published on the website. Once the customers agree to take the services offered there would be a separate agreement between the parties concerned and all liabilities would be governed by that separate agreement. There would be a separate agreement between the borrower and the Lender.

On-boarding
a. To avail the Services, you would be required to create a profile/sign-up on the Website ("Profile") using your email ID and phone number, among other details. You warrant that all information furnished in connection with your Profile is and shall remain accurate and true in all respects. You further agree and undertake to promptly update your details on the Website in the event of any change or modification of such details.

b. You are solely responsible for maintaining the security and confidentiality of your username and password and agree to immediately notify the Company in writing of any disclosure or unauthorized use of your Profile or any other breach of security with respect to your Profile.

c. You expressly agree to be liable and accountable for all activities that take place through your Profile in furtherance of the use of the Website or the Service provided or otherwise. The Company expressly excludes any liability for any unauthorised access to your Profile.

Third Party Services
a. The Services may include services, content, documents, and information owned by, licensed to, or otherwise made available by a third party ("Third Party Services") or contain links to Third Party Services. You understand that Third Party Services are the responsibility of the third party that created or provided the services and acknowledge that use of such Third-Party Services is solely at your own risk.

b. The Company makes no representations and hereby expressly excludes all warranties and liabilities arising out of or pertaining to such Third-Party Services, including the accuracy or completeness. Further, all intellectual property rights in and to Third Party Services are the property of the respective third parties.

Limitation of Liability
The Company does not hold any liability for any occurrence arising from your usage of our Services resulting in any financial, material or human damage. You understand and agree that Company shall not be liable to you for any direct, indirect, incidental, special, consequential or exemplary damages, including without limitation damages for loss of profits, goodwill, use, data or other intangible losses (even if Company had been advised of the possibility of such damages), resulting from or relating to the Websites or Mobile application, whether based on warranty, contract, tort, or any other legal theory.

Liability Cap: Notwithstanding anything to the contrary contained herein or elsewhere, Company's total liability for any user's claim which may arise out of availing our services through browsing websites/mobile app or elsewhere shall be limited up to the fees paid by such user at the time of availing the Services giving rise to such claim.

Claims Timeline
All claims/complaints arising from and in connection with the use of our Services shall be promptly submitted or reported to the Company and or/ its Partners within thirty (30) days of the consumption of such Services. Any claim or complaint that is submitted / reported after the expiry of such 30 days may be rejected, and the claimant will forfeit the right to claim any damage, cost or compensation.

Term and Termination
a. These Terms shall remain in effect unless terminated in accordance with the terms hereunder.

b. The Company may terminate your access to or use of the Services, or any portion thereof, immediately and at any point, at its sole discretion, if the user violates or breaches any of its obligations, responsibilities, or covenants under these Terms.

c. Upon termination these Terms shall terminate, except for those clauses that expressly or are intended to survive termination or expiry.

d. Notwithstanding anything to the contrary contained in the Terms, upon termination of your access to or use of the Services, all amounts or outstanding monies due by you in relation to your use of or access to the Services shall become immediately payable.

Disclaimers and Warranties
a. The use of the Services is at your sole risk.

b. To the extent permitted by applicable law, the Services are provided on an "as is" and "as available" basis. The Company does not warrant that operation of the Services will be uninterrupted or error free or that the functions contained in the Services will meet your requirements.

c. To the fullest extent permissible under applicable law, the Company expressly disclaims all warranties of any kind, express or implied, arising out of the Services, including warranties of merchantability, fitness for a particular purpose, satisfactory quality, accuracy, title and non-infringement, compatibility, applicability, usability, appropriateness, and any warranty that may arise out of course of performance, course of dealing, or usage of trade.

d. You hereby accept full responsibility for any consequences that may arise from your use of the Services, and expressly agree and acknowledge that the Company shall have absolutely no liability with respect to the same.

e. To the fullest extent permissible by law, the Company, its affiliates, and its related parties each disclaim all liability to you for any loss or damage arising out of or due to:

Your use of or inability to use, or availability or unavailability of the Services, including any Third Party Services.
The occurrence or existence of any defect, interruption, or delays in the operation or transmission of information to, from, or through the Services, communications failure, theft, destruction or unauthorised access to the Company's records, programs, services, server, or other infrastructure relating to the Services;
The failure of the Services to remain operational for any period of time.

f. Notwithstanding anything to the contrary contained herein, neither the Company nor any of its affiliates or related parties shall have any liability to you or any third party for any indirect, incidental, special or consequential damages or any loss of revenue or profits arising under, directly or indirectly, or relating, in any manner whatsoever, to these Terms or the Services. To the maximum extent permitted by law, you agree to waive, release, discharge, and hold harmless the Company, its affiliated and subsidiary companies, its parent companies, and each of their directors, officers, employees, and agents, from any and all claims, losses, damages, liabilities, expenses and causes of action arising out of the Services.

Indemnity
You shall indemnify, defend at the Company's option, and hold the Company, its parent companies, subsidiaries, affiliates, and their officers, associates successors, assigns, licensors, employees, directors, agents, and representatives, harmless from and against any claim, demand, lawsuits, judicial proceeding, losses, liabilities, damages and costs (including, without limitation, from all damages, liabilities, settlements, costs and attorneys' fees) due to or arising out of your use of the Website or the Services provided, including any violation of these Terms or any infringement by you of any third party right or on account of any third party who may use your account with the Company.

Consent to Use Data
a. You agree that the Company and any third-party service providers it engages, may, in accordance with its privacy policy, collect and use your information and technical data and related information.

b. The Company may use information and data pertaining to your use of the Services for analytics, trends identification, and purposes of statistics to further enhance the effectiveness and efficiency of the Website and transfer the same to its group companies and service providers in furtherance of your access to these Services. You provide your consent to such use and sharing of your information.

c. Subject to applicable laws, the Company may be directed by law enforcement agencies or the government and related bodies to disclose data in relation to users in connection with criminal proceedings. You understand and agree that in such instances, the Company shall have the right to share such data with relevant agencies or bodies.

Fees/Charges
The Company reserves the right to charge a convenience fee for the Services and non-payment may result in denial of Services and/or action under applicable law.

Modification
The Company reserves the right at any time to add, modify or discontinue, temporarily or permanently, the Services (or any part thereof) with or without cause. The Company shall not be liable for any such addition, modification, suspension or discontinuation of the Services.

Jurisdiction, Governing Laws, and Dispute Resolution
These Terms shall be governed by and construed and enforced in accordance with the laws of India. Subject to other provisions in this Clause, courts in Delhi shall have exclusive jurisdiction over all issues arising out of these Terms or the use of the Services.

Any controversies, conflicts, disputes, or differences arising out of these Terms shall be resolved by arbitration in Delhi in accordance with the Arbitration and Conciliation Act, 1996 for the time being in force, which is deemed to be incorporated by reference in this Clause. The tribunal shall consist of 1 (one) arbitrator appointed by the Company. The language of the arbitration shall be English.

The parties to the arbitration shall keep the arbitration confidential and not disclose to any person, other than on a need to basis or to legal advisors, unless required to do so by law. The decision of the arbitrator shall be final and binding on all the Parties hereto. Each party to the arbitration shall bear its own costs with respect to any dispute.

Miscellaneous Provisions
a. Modification
The Company reserves the right at any time to modify these Terms and to add new or additional terms or conditions on use of the Services. Such modifications and additional terms and conditions will be communicated to you and, unless expressly rejected (in which these Terms shall terminate), will be effective immediately and will be incorporated into these Terms. In the event you refuse to accept such changes, these Terms will terminate.

b. Severability
If any provision of these Terms is determined by any court or other competent authority to be unlawful or unenforceable, the other provisions of these Terms will continue in effect. If any unlawful or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect (unless that would contradict the clear intention of the clause, in which case the entirety of the relevant provision will be deemed to be deleted).

c. Assignment
You shall not license, sell, transfer or assign your rights, obligations, or covenants under these Terms in any manner without the Company's prior written consent. The Company may grant or withhold this consent in its sole discretion and subject to any conditions it deems appropriate. The Company may assign its rights to any of its affiliates, subsidiaries, or parent companies, or to any successor in interest of any business associated with the Services without any prior notice to you.

d. Notices
All notices, requests, demands, and determinations for the Company under these Terms (other than routine operational communications) shall be sent to care@finncube.com

e. Third Party Rights
No third party shall have any right to enforce any terms contained herein.`;

const headingLines = new Set([
    'Important Notice',
    'Who Are We and What Do We Do?',
    'Service Availability',
    'Services',
    'Liability Disclaimer',
    'On-boarding',
    'Third Party Services',
    'Limitation of Liability',
    'Claims Timeline',
    'Term and Termination',
    'Disclaimers and Warranties',
    'Indemnity',
    'Consent to Use Data',
    'Fees/Charges',
    'Modification',
    'Jurisdiction, Governing Laws, and Dispute Resolution',
    'Miscellaneous Provisions',
]);

const sectionLines = toLines(termsText);

function TermsAndCondition() {
    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <div>
                        <p style={styles.eyebrow}>Legal</p>
                        <h1 style={styles.title}>Terms and Conditions</h1>
                        <p style={styles.subtitle}>Please read these terms carefully before using FinnCube services.</p>
                    </div>
                    {/* <div style={styles.meta}>
                        <span style={styles.metaLabel}>Last updated</span>
                        <strong>March 7, 2026</strong>
                    </div> */}
                </div>

                <div style={styles.card}>
                    {sectionLines.map((line, index) => (
                        headingLines.has(line) ? (
                            <h2 key={`${line}-${index}`} style={styles.sectionHeading}>{line}</h2>
                        ) : (
                            <p key={`${line}-${index}`} style={styles.paragraph}>{line}</p>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
}

const styles = {
    page: {
        height: '100vh',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #fff7ed 0%, #fffaf5 45%, #f8fafc 100%)',
        overflowY: 'auto',
        padding: '32px 20px 48px',
    },
    container: {
        width: '100%',
        maxWidth: '1080px',
        margin: '0 auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '24px',
        flexWrap: 'wrap',
        marginBottom: '24px',
    },
    eyebrow: {
        margin: '0 0 8px',
        color: '#ea580c',
        fontSize: '0.92rem',
        fontWeight: 800,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
    },
    title: {
        margin: '0 0 10px',
        fontSize: 'clamp(2rem, 4vw, 3.25rem)',
        color: '#0f172a',
    },
    subtitle: {
        margin: 0,
        color: '#475569',
        fontSize: '1.08rem',
        lineHeight: 1.6,
        maxWidth: '760px',
    },
    meta: {
        minWidth: '180px',
        background: '#ffffff',
        border: '1px solid #fed7aa',
        borderRadius: '18px',
        padding: '16px 18px',
        boxShadow: '0 10px 30px rgba(234, 88, 12, 0.08)',
        color: '#0f172a',
    },
    metaLabel: {
        display: 'block',
        marginBottom: '6px',
        color: '#64748b',
        fontSize: '0.85rem',
        textTransform: 'uppercase',
        letterSpacing: '0.12em',
        fontWeight: 700,
    },
    card: {
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '28px',
        padding: '32px',
        boxShadow: '0 24px 80px rgba(15, 23, 42, 0.08)',
    },
    sectionHeading: {
        margin: '28px 0 12px',
        fontSize: '1.45rem',
        fontWeight: 800,
        color: '#0f172a',
    },
    paragraph: {
        margin: '0 0 14px',
        color: '#334155',
        fontSize: '1rem',
        lineHeight: 1.75,
        whiteSpace: 'pre-wrap',
    },
};

export default TermsAndCondition;
